import { NETWORK } from '@/src/helpers';

export const defaultPricePairOracles = [
  {
    base_asset: 'ACGBT',
    quote_asset: 'AUD',
    network: 'xrpl:1' as NETWORK,
    oracles: [{ oracle_document_id: '1234', account: 'rah4F6vuNnRibiqDcMsNC9dXoqBVoqczGZ' }],
  },
  {
    base_asset: 'ACGBT',
    quote_asset: 'USD',
    network: 'xrpl:1' as NETWORK,
    oracles: [{ oracle_document_id: '1234', account: 'rah4F6vuNnRibiqDcMsNC9dXoqBVoqczGZ' }],
  },
];

/** Additional blank price pair oracle when the user wants to add a new price pair oracle */
export const additionalPricePairOracle = [
  {
    base_asset: '',
    quote_asset: '',
    network: 'xrpl:1' as NETWORK,
    oracles: [{ oracle_document_id: '', account: '' }],
  },
];
